import React from "react";

const PrivacyLight = () => {
  return (
    <svg
      width="196"
      height="78"
      viewBox="0 0 196 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M78.7545 -89.0117L81.4733 -83.1803C82.7411 -80.461 85.9832 -79.2889 88.7025 -80.5568C115.836 -93.2075 148.185 -81.5124 160.836 -54.3788C173.487 -27.2452 161.746 5.00629 134.613 17.657L123.088 23.0301M117.025 -6.92698L122.37 -9.41874C134.735 -15.1838 139.909 -30.0885 133.922 -42.3475C128.069 -54.3315 113.689 -59.5999 101.543 -54.0922L89.6095 -48.6813M58.2201 -34.4482L55.6131 -33.2661C36.2196 -24.4724 27.7338 -1.53966 36.7319 17.7598L37.3687 19.1255C46.648 39.0281 70.3045 47.6399 90.207 38.3605L92.2102 37.4266"
        stroke="#434343"
        strokeWidth="13.7244"
        strokeLinecap="round"
      />
      <path
        d="M115.261 44.1352C107.311 47.8421 97.8065 44.3899 94.0592 36.3526C90.3119 28.3153 93.7776 18.816 101.728 15.1092C109.679 11.4023 119.183 14.8545 122.93 22.8918C126.678 30.9291 123.212 40.4283 115.261 44.1352Z"
        stroke="#434343"
        strokeWidth="13.7244"
      />
      <path
        d="M71.8736 31.9835C74.8388 43.0862 78.3361 53.1719 88.2636 59.721"
        stroke="#434343"
        strokeWidth="13.7244"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default PrivacyLight;
